import { NamePath } from 'antd/es/form/interface';
import FormSelect from 'components/form/FormSelect';
import { InfinitySelectProps } from 'components/form/InfinitySelect';

interface IFilterComponentProps {
  name?: NamePath;
  nameInRoot?: NamePath;
  reference?: InfinitySelectProps;
}

export default function FilterComponent({
  name,
  nameInRoot,
  reference,
}: IFilterComponentProps) {
  return (
    <FormSelect
      nameFormItem={name}
      name={nameInRoot}
      rules={[{ required: true, message: 'Missing value' }]}
      reference={reference}
      placeholder="No selection"
      className="min-w-[220px]"
    />
  );
}
